export default __webpack_public_path__ + "static/media/displayImg.11ee6304.JPG";